export default __webpack_public_path__ + "static/6-6d71142c706ab34834c8780944f94bd6.jpg";